<template>
	<div class="childDiv1" id="page4" ref="mainEl" page="4">
		<!-- God's ray -->
		<div class="absolute w-full top-0 z-[20] flex justify-center items-center pointer-events-none opacity-0" ref="raysEl">
			<img alt="" src="images/2x_images/section1/page4/ray1.png" class="absolute opacity-[0.7] top-0 left-0" ref="ray1El" />
			<img alt="" src="images/2x_images/section1/page4/ray2.png" class="absolute opacity-[0.5] top-[-100px] right-[-630px] origin-[top_center] rotate-[35deg]" ref="ray2El" />
			<img alt="" src="images/2x_images/section1/page4/ray3.png" class="absolute opacity-[0.2] top-[-100px] right-[-630px] origin-[top_center] rotate-[35deg]" ref="ray3El" />
		</div>

		<!-- aging BG -->
		<div class="w-full h-full flex justify-center items-center pointer-events-none absolute top-0 opacity-0" ref="agingBgEl">
			<img alt="" src="images/1x_images/section1/page4/aging.png" srcset="images/2x_images/section1/page4/aging.png 2x" class="w-full h-full" />
		</div>

		<div class="childWrapper">
			<div class="relative h-full" ref="wrapEl">
				<!-- <img alt="" src="images/test.png" class="absolute top-0 left-0 opacity-[0.3] w-full" /> -->
				<!-- <img alt="" src="images/page2-test.png" class="absolute w-full z-[20] pointer-events-none opacity-[0.4]" /> -->
				<img alt="" src="images/1x_images/section1/page4/page4-title.png" srcset="images/2x_images/section1/page4/page4-title.png 2x" class="absolute center top-[290px] z-[20] pointer-events-none" />
				<img alt="" src="images/1x_images/section1/page4/page4-btn.png" srcset="images/2x_images/section1/page4/page4-btn.png 2x" class="button absolute center top-[1148px] z-[9]" @click="showVideo()" ref="btnBtmEl" />

				<!-- buttons -->
				<div class="relative buttons flex center w-fit gap-[20px] top-[130px]">
					<div v-for="x in buttons" :key="x" class="button w-fit will-change-transform z-[50] shrink-0 flex justify-center items-center" @click="toggle($event, x)">
						<img alt="" :src="`images/1x_images/section1/page4/btn-${x}.png`" :srcset="`images/2x_images/section1/page4/btn-${x}.png 2x`" class="" />
						<div class="absolute flex items-center justify-center top-[75px]">
							<img alt="" :src="`images/1x_images/section1/page4/circle${currentShowing.includes(x) ? '-active' : ''}.png`" :srcset="`images/2x_images/section1/page4/circle${currentShowing.includes(x) ? '-active' : ''}.png 2x`" class="" />
							<img
								alt=""
								:src="`images/1x_images/section1/page4/icon-${x}${currentShowing.includes(x) ? '-active' : ''}.png`"
								:srcset="`images/2x_images/section1/page4/icon-${x}${currentShowing.includes(x) ? '-active' : ''}.png 2x`"
								class="absolute"
							/>
						</div>
					</div>
				</div>

				<!-- actual cells -->
				<Cell :pWidth="333" :style="{ opacity: mainCellOpacity }" class="absolute z-[5] top-[396px] left-[329px] rotate-[0deg]" ref="mainCellEl_1" />
				<Cell :pWidth="290" :style="{ opacity: mainCellOpacity }" class="absolute z-[4] top-[563px] left-[140px] rotate-[40deg]" ref="mainCellEl_2" />
				<Cell :pWidth="290" :style="{ opacity: mainCellOpacity }" class="absolute z-[4] top-[580px] left-[564px] rotate-[100deg]" ref="mainCellEl_3" />
				<Cell :pWidth="322" :style="{ opacity: mainCellOpacity }" class="absolute z-[5] top-[824px] left-[444px] rotate-[230deg]" ref="mainCellEl_4" />

				<!-- fake cells -->
				<Cell2 :pWidth="422" class="absolute z-[3] top-[200px] left-[105px] rotate-[30deg]" ref="smallCellEl_1" />
				<Cell2 :pWidth="380" class="absolute z-[3] top-[600px] left-[-120px] rotate-[60deg]" ref="smallCellEl_2" />
				<Cell2 :pWidth="250" class="absolute z-[3] top-[400px] left-[650px] rotate-[100deg]" ref="smallCellEl_3" />
				<Cell2 :pWidth="422" class="absolute z-[3] top-[900px] left-[600px] rotate-[120deg]" ref="smallCellEl_4" />
				<Cell2 :pWidth="300" class="absolute z-[3] top-[1050px] left-[130px] rotate-[250deg]" ref="smallCellEl_5" />

				<!-- transparent cells -->
				<div v-for="x in cells" class="absolute aspect-square bg-[antiquewhite] rounded-full z-[20] opacity-0" :key="x" ref="cellsEl" :style="{ width: `${x.width}px`, top: `${x.top}px`, left: `${x.left}px` }"></div>

				<!-- particles -->
				<Particles
					class="z-[9] pointer-events-none"
					:configs="{ type: 'normal', black: 0.4, gold: 0.6, interval: { min: 100, max: 1000 }, cellPos: cells, size: { min: 22, max: 36 }, goldAbsorbRate: 1, blackAbsorbRate: blackAbsorb }"
					ref="particlesEl"
					@shrinkCell="shrinkCell"
				/>

				<!-- stress particles -->
				<Particles class="z-[9] pointer-events-none" :configs="{ type: 'stress', interval: { min: 300, max: 1800 }, cellPos: cells, size: { min: 45, max: 70 } }" ref="stressParticlesEl" />

				<!-- dust particles -->
				<ParticlesDust class="z-[9] pointer-events-none" ref="dustParticlesEl" />
			</div>
		</div>

		<!-- video modal -->
		<div class="modal z-[999]" ref="modalEl">
			<div class="childWrapper">
				<img alt="" class="button relative top-[180px] center" src="images/1x_images/btn-close.png" srcset="images/2x_images/btn-close.png 2x" @click="close()" />
				<div class="absolute top-[300px] w-full">
					<VideoComp :url="'videos/Video-Skin-intel.mp4'" :poster="'videos/Poster-skin-intel.png'" ref="videoEl" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";
import Cell from "../../components/BubbleDraw1.vue";
import Cell2 from "../../components/BubbleDraw2.vue";
import Particles from "../../components/Particles.vue";
import ParticlesDust from "../../components/ParticlesDust.vue";
import VideoComp from "../../components/Videos.vue";

export default {
	name: "page-1",
	components: { Cell, Cell2, Particles, ParticlesDust, VideoComp },
	data() {
		return {
			animate: true, // always true, false only for testing

			cells: [
				{ width: 166, top: 490, left: 415 },
				{ width: 134, top: 660, left: 225 },
				{ width: 135, top: 670, left: 640 },
				{ width: 165, top: 900, left: 520 },
				// { width: 300, top: 500, left: 650 },
			],
			markers: [],
			stopped: true,
			tweens: [],
			buttons: ["all", "uv", "stress", "aging", "pollution"],
			previousShowing: [],
			currentShowing: [],
			mainCellOpacity: 1,
			blackAbsorb: 0,
		};
	},
	methods: {
		initAnimateBgCells() {
			for (var i = 1; i <= 5; i++) {
				var element = this.$refs[`smallCellEl_${i}`].$el;
				this.animateBgCells(element);
			}
		},
		animateBgCells(element) {
			var moveY = Math.floor(Math.random() * 20 - 10);
			var currentY = gsap.getProperty(element, "y");
			var speed = 5;
			var duration = Math.abs(currentY - moveY) / speed;
			this.context.add(() => {
				// prettier-ignore
				gsap.to(element, { y: moveY, duration: duration, ease: "sine.inOut", onComplete: ()=> {
					this.animateBgCells(element);
				}})
			});
		},
		initAnimateLight(animate) {
			this.context.add(() => {
				this.animateLight2(this.$refs.ray2El, animate);
				this.animateLight3(this.$refs.ray3El, animate);
			});
		},
		animateLight2(el, animate) {
			// console.log("animateLight2", animate);
			if (animate) {
				var opacityR = Math.random() * 0.6 + 0.1;
				var durationR = Math.random() * 1.5 + 0.5;
				// console.log(opacityR, durationR);
				gsap.to(el, { opacity: opacityR, duration: durationR, ease: "none", onComplete: () => this.animateLight2(el, true) });
			} else {
				gsap.set(el, { opacity: 0, overwrite: true });
			}
		},
		animateLight3(el, animate) {
			// console.log("animateLight3", animate);
			if (animate) {
				var opacityR = Math.random() * 0.3 + 0.1;
				var durationR = Math.random() * 2 + 1;
				// console.log(opacityR, durationR);
				gsap.to(el, { opacity: opacityR, duration: durationR, ease: "none", onComplete: () => this.animateLight3(el, true) });
			} else {
				gsap.set(el, { opacity: 0, overwrite: true });
			}
		},
		shrinkCell(data) {
			const el = this.$refs[`mainCellEl_${data + 1}`].$el;
			gsap.to(el, { scale: 0.7, duration: 10, ease: "none", overwrite: true });
		},
		toggle(event, type) {
			if (type == "all") {
				if (this.currentShowing.includes(type)) {
					this.currentShowing = [];
				} else {
					this.buttons.forEach((element) => {
						if (!this.currentShowing.includes(element)) {
							this.currentShowing.push(element);
						}
					});
				}
			} else {
				if (this.currentShowing.includes(type)) {
					var removeEl = this.currentShowing.indexOf(type);
					this.currentShowing.splice(removeEl, 1);
					if (this.currentShowing.includes("all")) {
						this.currentShowing.splice(this.currentShowing.indexOf("all"), 1);
					}
				} else {
					this.currentShowing.push(type);
					if (this.currentShowing.length == this.buttons.length - 1) {
						this.currentShowing.push("all");
					}
				}
			}

			var element = event.currentTarget;
			gsap.set(element, { scale: 1.1 });
			gsap.to(element, { scale: 1, duration: 0.4, force3D: true, ease: "expo.out", delay: 0.1 });
			this.updateEnvironment();
		},
		updateEnvironment(reset = false) {
			console.log("previousShowing", this.previousShowing);
			this.buttons.forEach((type) => {
				if (type != "all") {
					if (this.currentShowing.includes(type)) {
						if (!this.previousShowing.includes(type)) {
							this.show(type, true);
						}
					} else {
						if (this.previousShowing.includes(type)) {
							this.show(type, false);
						}
					}
				}
			});
			this.previousShowing = [...this.currentShowing];
			if (this.currentShowing.length == 0) {
				for (var i = 1; i <= 4; i++) {
					gsap.to(this.$refs[`mainCellEl_${i}`].$el, { scale: 1, duration: 0.3, ease: "none", overwrite: true });
				}
			}
			this.blackAbsorb = this.currentShowing.length > 0 ? 0.5 : 0;
		},
		show(type, state) {
			if (type == "uv") {
				gsap.to(this.$refs.raysEl, { autoAlpha: state == true ? 1 : 0, duration: 1, ease: "none" });
				this.initAnimateLight(state);
			} else if (type == "aging") {
				gsap.to(this.$refs.agingBgEl, { autoAlpha: state == true ? 1 : 0, duration: 0.8, ease: "none" });
				gsap.to(this, { mainCellOpacity: state == true ? 0.8 : 1, duration: 0.8, ease: "none" });
			} else if (type == "stress") {
				if (state == true) {
					this.$refs.stressParticlesEl.start();
				} else {
					this.$refs.stressParticlesEl.stop();
				}
			} else if (type == "pollution") {
				if (state == true) {
					this.$refs.dustParticlesEl.start();
				} else {
					this.$refs.dustParticlesEl.stop();
				}
			}
		},
		showVideo() {
			gsap.set("#main_nav", { autoAlpha: 0 });
			gsap.set(".page1-menu", { autoAlpha: 0 });
			gsap.set(this.$refs.modalEl, { autoAlpha: 1 });
			this.$refs.videoEl.start();
		},
		close() {
			gsap.set("#main_nav", { autoAlpha: 1 });
			gsap.set(".page1-menu", { autoAlpha: 1 });
			gsap.set(this.$refs.modalEl, { autoAlpha: 0 });
			this.$refs.videoEl.reset();
		},
		reset() {
			this.currentShowing = [];
			this.updateEnvironment();
			gsap.set(this.$refs.modalEl, { autoAlpha: 0 });
		},
		stop() {
			console.log("stop page 4");
			this.stopped = true;
			this.$refs.particlesEl.stop();
			this.$refs.stressParticlesEl.stop();
			for (var i = 1; i < 4; i++) {
				this.$refs[`mainCellEl_${i}`].stop();
			}
			if (this.context) this.context.revert();
			this.reset();
		},
		start() {
			console.log("start page 4");
			this.stopped = false;

			this.$nextTick(() => {
				if (this.animate) {
					// this.initAnimateBgCells();
					for (var i = 1; i <= 4; i++) {
						this.$refs[`mainCellEl_${i}`].start();
					}
					this.$refs.particlesEl.start();
				}
			});
		},
	},
	mounted() {
		this.reset();
		this.context = gsap.context(() => {}, this.$el); // Scope to the component's root element
		gsap.set(this.$refs.wrapEl, { top: aspectRatio < 0.74 ? 0 : "40px" });
		// gsap.set(this.$refs.btnBtmEl, { bottom: aspectRatio < 0.74 ? 0 : "40px" });

		// this.start();
		// for (var i = 0; i < 200; i++) {
		// 	var willStick = Math.random() * 1;
		// 	console.log(willStick);
		// }
	},
};
</script>

<style></style>
